import type { Locale } from "./i18n";
import type { OpportunityStatus } from "../types";

const chineseLabels: Record<OpportunityStatus, string> = {
  Introduced: "已介绍",
  Contacted: "已联系",
  "Discovery in progress": "需求了解中",
  "Solution design": "方案设计中",
  "Proposal submitted": "方案已提交",
  "Client reviewing": "客户审核中",
  "Commercial negotiation": "商务谈判中",
  Contracting: "合同处理中",
  "Payment pending": "待付款",
  "Paid - delivery pending": "已付款，待交付",
  "Delivery in progress": "交付进行中",
  "Live - post-launch support": "已上线，售后支持中",
  Completed: "已完成",
  "On hold": "暂停",
  "Closed - not proceeding": "已关闭，不再推进",
};

export function statusLabel(status: OpportunityStatus, locale: Locale): string {
  return locale === "zh-CN" ? chineseLabels[status] : status;
}
